import Big from 'big.js';
// eslint-disable-next-line import/no-extraneous-dependencies
import IntlMessageFormat from 'intl-messageformat';

const getEnergyPricePowertracerToPartnerMultiplier = (intl) => {
  // eslint-disable-next-line formatjs/enforce-placeholders
  const multiplier = intl.formatMessage({ id: 'math.energy_price.powertracer_to_partner', defaultMessage: '{n, number, :: ,_ scale/100000}' });

  const formatter = new IntlMessageFormat(multiplier, 'en');
  const formattedValue = String(formatter.format({ n: 1 }));

  return Big(formattedValue);
};

/**
 * Convert energy prices from dollars per wh to cents per kwh
 * @param {import('react-intl').IntlShape} intl - intl object
 * @param {number} price
 * @returns {Big | null} - price in c/kwh
 */
export const convertEnergyPricePowertracerToPartner = (intl, price) => {
  if (price == null || Number.isNaN(price)) {
    return null;
  }

  try {
    return (Big(price).times(getEnergyPricePowertracerToPartnerMultiplier(intl)));
  } catch (error) {
    // If Big.js throws an error, return null gracefully
    return null;
  }
};

/**
 * Convert energy prices from cents per wh to dollars per kwh
 * @param {import('react-intl').IntlShape} intl
 * @param {number} price
 * @returns {Big | null} - price in c/kwh
 */
export const convertEnergyPricePartnerToPowertracer = (intl, price) => {
  if (price === 0) {
    return Big(0);
  }

  // Handle edge cases that would cause Big.js to throw "Invalid number" error
  if (price == null || Number.isNaN(price) || typeof price !== 'number') {
    return null;
  }

  try {
    return (Big(price).div(getEnergyPricePowertracerToPartnerMultiplier(intl)));
  } catch (error) {
    // If Big.js throws an error, return null gracefully
    return null;
  }
};
